<p>
  offer-asset-upload works!
</p>
